// Camera for the 2.5D map view (MapBoxMap `perspective` prop). Kept out of MapBoxMap, which is dynamically imported.
export const DEFAULT_PERSPECTIVE = { pitch: 45, bearing: -20 };
